// extracted by mini-css-extract-plugin
export default {"video-link":"c_g d-flex align-items-center my-2","video-link__link":"c_h ml-2"};